module.exports = __webpack_public_path__ + "static/media/whiteBell.f9b0c51c.svg";